import React from 'react';
import { useMemo } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import { seconds2HMS } from "src/components/utils/utils";
import { faPhoneHangup, faBellOn, faPhoneArrowDownLeft, faPhoneVolume, faPhoneArrowUpRight, faCirclePause } from "@fortawesome/pro-duotone-svg-icons";
function PhoneStatus({ agent }) {

    const { t } = useTranslation();
    const hangupLabel = t("hangup");
    const talkingLabel = t("talking");
    const ringingLabel = t("ringing");
    const dialingLabel = t("dialing");
    const onHoldLabel = t("onhold");
    const maxTalkingTimeLabel = t("maxtalkingtime");

    const title = useMemo((data) => {

        let text = hangupLabel;
        let alarm = "";

        if (agent?.strStatus?.toLowerCase() === "talking") {
            text = talkingLabel;

            if (agent.ringing) text = ringingLabel;
            if (agent.dialing) text = dialingLabel;
            if (agent.hold) text = onHoldLabel;
            if (agent.currentCallAlarm) alarm = " - " + maxTalkingTimeLabel;

            text += " - " + seconds2HMS(agent.hold ? agent.holdTime : agent.currentCallDuration);
        }

        return text + alarm
    }, [agent, hangupLabel, talkingLabel, ringingLabel, dialingLabel, onHoldLabel, maxTalkingTimeLabel]);


    const getStatus = useMemo(() => {
        let content = <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={faPhoneHangup} />

        if (agent?.strStatus?.toLowerCase() === "talking") {
            if (agent.ringing) {
                content = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={faBellOn} shake />

            } else {

                if (agent.incomingCall) {
                    content = <FontAwesomeIcon className="px-1 text-success" size="lg" icon={faPhoneArrowDownLeft} />
                    if (agent.currentCallAlarm) {
                        content = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={faPhoneArrowDownLeft} />
                    }
                } else {
                    if (agent.dialing) {
                        content = <FontAwesomeIcon className="px-1 text-primary" size="lg" icon={faPhoneVolume} />
                    } else {
                        content = <FontAwesomeIcon className="px-1 text-primary" size="lg" icon={faPhoneArrowUpRight} />
                        if (agent.currentCallAlarm) {
                            content = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={faPhoneArrowUpRight} />
                        }
                    }
                }

                if (agent.hold) {
                    content = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={faCirclePause} />
                }
            }
        }
        return content;
    }, [agent]);

    return (
        <div style={{ display: "inline-block" }} title={title}>
            {getStatus}
        </div>);
}


export default PhoneStatus